import { STATUS, fmtNum } from "../lib/fmt";

export const Section = ({ id, eyebrow, title, right, children, testid }) => (
  <section id={id} data-testid={testid || `section-${id}`} className="fade-up py-7 sm:py-9">
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
      <div>
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h2 className="mt-1 text-xl font-extrabold tracking-tight sm:text-2xl">{title}</h2>
      </div>
      {right}
    </div>
    {children}
  </section>
);

export const StatusPill = ({ status, testid }) => {
  const s = STATUS[status] || STATUS.ontrack;
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const KpiChips = ({ kpi, labels }) => {
  const entries = Object.entries(kpi || {});
  if (!entries.length) return <span className="text-xs text-[#9b8a8b]">–</span>;
  return (
    <div className="flex flex-wrap gap-1.5">
      {entries.map(([k, v]) => (
        <span key={k} className="rounded-lg bg-brand-soft px-2 py-0.5 text-xs text-brand-ink">
          {labels[k] || k} <b className="text-brand">{fmtNum(v)}</b>
        </span>
      ))}
    </div>
  );
};

export const Bullets = ({ text }) => {
  const items = (text || "").split("\n").filter(Boolean);
  if (!items.length) return <span className="text-[#9b8a8b]">–</span>;
  return (
    <ul className="list-disc space-y-0.5 pl-4 marker:text-brand">
      {items.map((t, i) => <li key={i}>{t}</li>)}
    </ul>
  );
};

export const Toggle = ({ options, value, onChange, testid }) => (
  <div data-testid={testid} className="inline-flex rounded-full border border-brand-line bg-white p-1">
    {options.map(([v, label]) => (
      <button
        key={v}
        data-testid={`${testid}-${v}`}
        onClick={() => onChange(v)}
        className={`min-h-[36px] rounded-full px-4 text-sm font-bold transition-colors ${value === v ? "bg-brand text-white" : "text-brand-ink hover:text-brand"}`}
      >
        {label}
      </button>
    ))}
  </div>
);

export const Tile = ({ label, value, sub, accent, testid }) => (
  <div data-testid={testid} className={`card p-4 ${accent ? "border-brand/30 bg-brand-soft" : ""}`}>
    <div className="text-xs font-semibold text-[#7a6667]">{label}</div>
    <div className={`mt-1 text-2xl font-extrabold tabular-nums ${accent ? "text-brand" : ""}`}>{value}</div>
    {sub && <div className="mt-0.5 text-xs text-[#7a6667]">{sub}</div>}
  </div>
);

export const Block = ({ title, children, testid }) => (
  <div data-testid={testid} className="card p-4 sm:p-5">
    <h3 className="mb-4 text-base font-extrabold text-brand-deep">{title}</h3>
    {children}
  </div>
);

export const kpiLabelMap = (jobFunctions) => {
  const m = {};
  (jobFunctions || []).forEach((f) => f.kpi.forEach((k) => { m[k.key] = k.label; }));
  return m;
};
